export default __webpack_public_path__ + "static/sublimation-ad4fcbc1639ac588187663db5e515820.jpg";